import { logoutRequest } from "@Store/App/actions";
import { selectLogoutSuccess } from "@Store/App/selectors";
import { FrownOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "@hooks";
import MainComponent from "@src/MainComponent";
import { Button, Result } from "antd";
import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

function UnauthorizedPage() {
  const { t } = useTranslation();
  const dispatch: ReturnType<typeof useAppDispatch> = useAppDispatch();

  const logoutSuccess: boolean = useAppSelector(selectLogoutSuccess);

  const handleLogout: MouseEventHandler<HTMLElement> = () => {
    dispatch(logoutRequest());

    if (logoutSuccess) {
      window.location.reload();
    }
  };

  return (
    <MainComponent role="SIMPLE_USER">
      <div className="app__dashboard">
        <Result
          icon={<FrownOutlined />}
          title={t("unauthorized.title")}
          subTitle={t("unauthorized.message")}
          extra={
            <Button type="primary" onClick={handleLogout}>
              {t("sidebar.logout")}
            </Button>
          }
        />
      </div>
    </MainComponent>
  );
}

export default UnauthorizedPage;
